module.exports = __webpack_public_path__ + "static/img/gonggong-remen.20d6025.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gonggong-remen.png
// module id = heIe
// module chunks = 1